export const chatFastModeLabel = "Быстрый ответ";
export const chatFastModeHint =
  "Ищет по словам. Быстрее, без Wiki и без повторного поиска.";

export const chatDeepModeLabel = "Глубокий разбор";
export const chatDeepModeHint =
  "Несколько поисков по документам и Wiki. Модель сама выбирает, куда искать дальше.";

export const chatThinkingLabel = "Размышление";
export const chatThinkingHint =
  "Модель думает дольше, затем отвечает. Только для этого чата, настройки организации не меняются.";

export const chatAllPeriodsLabel = "По всем периодам";
export const chatAllPeriodsHint =
  "Ищет и в действующих, и в устаревших редакциях. Срок действия версий не отфильтровывает источники.";

export function parseChatAllPeriods(value: unknown): boolean {
  return value === true || value === "true";
}

export function parseChatReasoning(value: unknown): boolean | null {
  if (value === true || value === "true") {
    return true;
  }
  if (value === false || value === "false") {
    return false;
  }
  return null;
}

export function resolveChatReasoning(
  conversation: boolean | null | undefined,
  tenantDefault: boolean,
): boolean {
  return conversation ?? tenantDefault;
}
